import { Injectable } from '@angular/core';
import { ApiControllers, GlobalServices } from '../global/global.service';
import { Observable } from 'rxjs';
import { TokenManagerPost, UserAnjana } from '../../models/core/auth.models';
import {
  AuthorizationApiRequest,
  AuthorizationRequestBody,
  CreateAuthorizationRequest,
  CreatedAuthorizationResponse,
  QueryAuthorizationRequest,
  QueryAuthorizationResponse,
  UpdatedAuthorizationResponse
} from '../../models/authorizations/authorizations-api.models';
import { ApiResponse, Procedure, S3UploadDocumentRequest, S3UploadDocumentResponse } from '../../models/core/api.models';
import { ServicioCodigoEnum } from '../../models/authorizations/service-codes.enum';
import { AuthenticationService } from '../authentication/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService extends GlobalServices {
  validateToken(data: TokenManagerPost): Observable<UserAnjana> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.AURORA}/tokens_manager`;
    return this.postSomething<UserAnjana>(url, data);
  }

  getProcedures(): Observable<ApiResponse<Procedure[]>> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.AURORA}/busqueda`;
    const request = {
      busqueda: 'procedimientos'
    };
    return this.postSomething(url, request);
  }

  createAuthorization(data: CreateAuthorizationRequest): Observable<CreatedAuthorizationResponse> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.SVCD_PREALTAS}`;
    const request: AuthorizationApiRequest<CreateAuthorizationRequest> = {
      action: ServicioCodigoEnum.PID_CREAR,
      request: this.getPrealtasGeneralData<CreateAuthorizationRequest>(data)
    };
    return this.postSomething<CreatedAuthorizationResponse>(url, request);
  }

  updateAuthorization(data: CreateAuthorizationRequest): Observable<UpdatedAuthorizationResponse> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.SVCD_PREALTAS}`;
    const request: AuthorizationApiRequest<CreateAuthorizationRequest> = {
      action: ServicioCodigoEnum.PID_ACTUALIZAR,
      request: this.getPrealtasGeneralData<CreateAuthorizationRequest>(data)
    };
    return this.postSomething<UpdatedAuthorizationResponse>(url, request);
  }

  queryAuthorization(procedure: number): Observable<QueryAuthorizationResponse> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.SVCD_PREALTAS}`;
    const request: AuthorizationApiRequest<QueryAuthorizationRequest> = {
      action: ServicioCodigoEnum.PID_CONSULTAR,
      request: this.getPrealtasGeneralData<QueryAuthorizationRequest>({
        Consulta: { CodigoProcedimiento: procedure.toString() }
      })
    };
    return this.postSomething<QueryAuthorizationResponse>(url, request);
  }

  private getPrealtasGeneralData<T>(data: T): AuthorizationRequestBody<T> {
    return {
      CredencialesSvcd_v1: {
        UserCode: AuthenticationService.User().eIdentifier,
        OrganismCode: AuthenticationService.User().orgCode
      },
      DatosGenericos: {
        Solicitante: {
          Funcionario: {
            NifFuncionario: AuthenticationService.User().eIdentifier,
            NombreCompletoFuncionario: AuthenticationService.UserCompleteName()
          },
          Procedimiento: {
            CodProcedimiento: environment.cod_procedimiento
          }
        }
      },
      DatosEspecificos: data
    };
  }

  getS3UploadDocumentUrl(file: File): Observable<S3UploadDocumentResponse> {
    const url = `${GlobalServices.URL_API_HOST}/${ApiControllers.SVCD_PREALTAS}`;
    const request: S3UploadDocumentRequest = {
      action: 'UPLOAD_URL',
      request: {
        fileName: file.name,
        contentType: file.type
      }
    };
    return this.postSomething<S3UploadDocumentResponse>(url, request);
  }

  uploadDocumentS3(url: string, file: File): Observable<void> {
    return this.httpClient.put<void>(url, file, {
      headers: {
        'Content-Type': file.type
      }
    });
  }
}
